module.exports = __webpack_public_path__ + "static/media/stjerne.f67a659d.m4a";